import React from 'react';
import type { EditorIconProps } from './EditorIconProps';

export const LlamaApps = ({
  color = 'currentColor',
  size = 40,
  ...props
}: EditorIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g transform="translate(7.5, 7.5)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.50005 2.50005V8.75018H8.75018V2.50005H2.50005ZM1.25003 0H10.0002C10.6906 0 11.2502 0.559656 11.2502 1.25003V10.0002C11.2502 10.6906 10.6906 11.2502 10.0002 11.2502H1.25003C0.559656 11.2502 0 10.6906 0 10.0002V1.25003C0 0.559656 0.559656 0 1.25003 0Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2505 2.50005V8.75018H22.5007V2.50005H16.2505ZM15.0005 0H23.7507C24.4411 0 25.0007 0.559656 25.0007 1.25003V10.0002C25.0007 10.6906 24.4411 11.2502 23.7507 11.2502H15.0005C14.3101 11.2502 13.7505 10.6906 13.7505 10.0002V1.25003C13.7505 0.559656 14.3101 0 15.0005 0Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2505 16.2504V22.5005H22.5007V16.2504H16.2505ZM15.0005 13.7503H23.7507C24.4411 13.7503 25.0007 14.31 25.0007 15.0003V23.7505C25.0007 24.4409 24.4411 25.0005 23.7507 25.0005H15.0005C14.3101 25.0005 13.7505 24.4409 13.7505 23.7505V15.0003C13.7505 14.31 14.3101 13.7503 15.0005 13.7503Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.50005 16.2504V22.5005H8.75018V16.2504H2.50005ZM1.25003 13.7503H10.0002C10.6906 13.7503 11.2502 14.31 11.2502 15.0003V23.7505C11.2502 24.4409 10.6906 25.0005 10.0002 25.0005H1.25003C0.559656 25.0005 0 24.4409 0 23.7505V15.0003C0 14.31 0.559656 13.7503 1.25003 13.7503Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

LlamaApps.displayName = 'LlamaApps';
